import React from "react"
import { Link } from "gatsby"
import DarkModeToggle from "./dark-mode-toggle"

const Logo = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="14" cy="14" r="14" fill="currentColor" />
  </svg>
)

const Header: React.FC = () => {
  return (
    <header className="sticky top-0 z-50 border-b border-border bg-bg-primary/80 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-3 text-accent hover:opacity-80 transition-opacity"
        >
          <Logo />
          <span
            className="font-semibold text-text-primary tracking-tight text-xl"
            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
          >
            Laputa Labs
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <Link
            to="/about"
            className="text-sm font-medium transition-colors text-text-secondary hover:text-text-primary [&[aria-current=page]]:text-text-primary"
          >
            About
          </Link>
          <Link
            to="/services"
            className="text-sm font-medium transition-colors text-text-secondary hover:text-text-primary [&[aria-current=page]]:text-text-primary"
          >
            Services
          </Link>
          <Link
            to="/projects"
            className="text-sm font-medium transition-colors text-text-secondary hover:text-text-primary [&[aria-current=page]]:text-text-primary"
          >
            Projects
          </Link>
          <Link
            to="/contributions"
            className="text-sm font-medium transition-colors text-text-secondary hover:text-text-primary [&[aria-current=page]]:text-text-primary"
          >
            Contributions
          </Link>
          <Link
            to="/blog"
            className="text-sm font-medium transition-colors text-text-secondary hover:text-text-primary [&[aria-current=page]]:text-text-primary"
          >
            Blog
          </Link>
          <Link
            to="/careers"
            className="text-sm font-medium transition-colors text-text-secondary hover:text-text-primary [&[aria-current=page]]:text-text-primary"
          >
            Careers
          </Link>
          <Link
            to="/contact"
            className="text-sm font-medium transition-colors text-text-secondary hover:text-text-primary [&[aria-current=page]]:text-text-primary"
          >
            Contact
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          <DarkModeToggle className="cursor-pointer" />
          {/* Mobile: show contact link */}
          <Link
            to="/contact"
            className="md:hidden btn-primary text-xs px-4 py-2"
          >
            Contact
          </Link>
        </div>
      </div>
    </header>
  )
}

export default Header
